<template>
	<section class="scene-place-checkins-index">
		<ChalkyUtilityTabGroup
			v-bind:key="venueCheckinsCollection.uniqueKey"
			v-bind:tabs="['Past Checkins']"
			v-slot="{ activeTab }"
		>
			<div v-show="activeTab === 'past-checkins'">
				<section class="grid" v-if="venueCheckinsCollection.uniqueKey && venueCheckinsCollection.length > 0">
					<ChalkyUserCardPreview
						class="list-item"
						v-bind:key="userModel.id"
						v-bind:userModel="userModel"
						v-for="userModel in venueCheckinsCollection"
						v-on:click.native="Handle_OnSelectUser($event, userModel)"
					/>
				</section>

				<section v-else>
					<ViewUiStateNoCheckins />
				</section>
			</div>
		</ChalkyUtilityTabGroup>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import SceneBase from '@/Core/Scene.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Place checkins scene displaying a list of users who have
	 * checked in at a venue. Receives collections from the parent
	 * Page and emits user selection events.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Scene/PlaceCheckins
	 * @project ChalkySticks App
	 */
	@Component
	export default class ScenePlaceCheckinsIndex extends SceneBase {
		/**
		 * Collection of venue checkins.
		 *
		 * @type ChalkySticks.Collection.VenueCheckin
		 */
		@Prop()
		public venueCheckinsCollection!: ChalkySticks.Collection.VenueCheckin;

		/**
		 * Fetches next page of checkin results.
		 * Called by the parent Page via $refs when AutoScroll triggers.
		 *
		 * @return Promise<void>
		 */
		public async loadMore(): Promise<void> {
			// 4 is an arbitrary amount to say that we have enough
			// results where we're probably scrolling
			if (this.venueCheckinsCollection.length > 4) {
				await this.venueCheckinsCollection.nextPage(true);
			}
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle user selection. Emits to parent for navigation.
		 *
		 * @param PointerEvent e
		 * @param ChalkySticks.Model.User userModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectUser(e: PointerEvent, userModel: ChalkySticks.Model.User): Promise<void> {
			this.$emit('user:select', e, userModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	// Layout
	// ---------------------------------------------------------------------------

	.scene-place-checkins-index {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}
</style>
